import { useContext } from 'react';

import type { ITableContext } from './TableContext';
import { TableContext } from './TableContext';

export const useTableContext = (): ITableContext | undefined =>
  useContext(TableContext);
